var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLavoroAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 339.341,
    height: 48,
    viewBox: "0 0 339.341 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.114,
    x2: 1,
    y2: 0.864,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#442eb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d8583d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa9c2b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30789",
    "data-name": "Group 30789",
    transform: "translate(-410.293 -672.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30787",
    "data-name": "Group 30787",
    transform: "translate(410.293 672.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15935",
    "data-name": "Path 15935",
    d: "M0,0H36A12,12,0,0,1,48,12v4.8H12A12,12,0,0,1,0,4.8Z",
    transform: "translate(0 31.2)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_632",
    "data-name": "Union 632",
    d: "M16.8,16.8V1.22a13.88,13.88,0,0,0,3.727,9.074C24.728,14.494,33.6,16.8,33.6,16.8Zm-4.8,0A12,12,0,0,1,0,4.8V0H16.8V16.8Z",
    transform: "translate(7.2 31.2)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_634",
    "data-name": "Union 634",
    d: "M16.8,16.8V1.22a13.88,13.88,0,0,0,3.727,9.074C24.728,14.494,33.6,16.8,33.6,16.8Zm-4.8,0A12,12,0,0,1,0,4.8V0H16.8V16.8Z",
    transform: "translate(3.6 31.2)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_633",
    "data-name": "Union 633",
    d: "M16.8,48V32.42a13.882,13.882,0,0,0,3.727,9.074C24.728,45.693,33.6,48,33.6,48ZM12,48A12,12,0,0,1,0,36V0H4.8a12,12,0,0,1,12,12V48Z",
    transform: "translate(0)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15949",
    "data-name": "Path 15949",
    d: "M47.93-149.8v-7.423H28.692v-35.2H20.28V-149.8Zm27.9-26.6A12.164,12.164,0,0,0,65.5-181.9c-9.278,0-15.959,7.361-15.959,16.7,0,9.031,6.557,16.33,15.711,16.33a12.817,12.817,0,0,0,10.515-5.381v4.454h7.67v-32.845Zm-9.155,20.289a8.989,8.989,0,0,1-9.217-9.278,9.039,9.039,0,0,1,9.278-9.278,9.223,9.223,0,0,1,9.278,9.278A9.2,9.2,0,0,1,66.672-156.106Zm38.041,7.546,17.134-32.412h-8.165L104.775-162.6l-8.969-18.371H87.579Zm34.825-.309c9.65,0,17.2-7.052,17.2-16.577S149-181.9,139.6-181.9c-9.34,0-17.072,6.928-17.072,16.516C122.528-155.921,130.012-148.869,139.538-148.869Zm0-7.237a9.05,9.05,0,0,1-9.093-9.34,8.959,8.959,0,0,1,9.155-9.217,8.974,8.974,0,0,1,9.217,9.217A9.127,9.127,0,0,1,139.538-156.106ZM170.9-180.972h-8.041V-149.8H170.9V-166c0-5.32,3.588-7.979,8.227-8.041a5.781,5.781,0,0,1,1.485.124V-181.9a11.628,11.628,0,0,0-9.711,4.887Zm28.763,32.1c9.65,0,17.2-7.052,17.2-16.577S209.126-181.9,199.724-181.9c-9.34,0-17.072,6.928-17.072,16.516C182.652-155.921,190.136-148.869,199.662-148.869Zm0-7.237a9.05,9.05,0,0,1-9.093-9.34,8.959,8.959,0,0,1,9.155-9.217,8.974,8.974,0,0,1,9.217,9.217A9.127,9.127,0,0,1,199.662-156.106Zm74.351,6.309-21.526-44.474L230.9-149.8h8.722l2.907-6.433h19.856l2.907,6.433Zm-21.526-28.454,7.113,15.773H245.312Zm29.629-7.485a5.534,5.534,0,0,0,5.505-5.381,5.545,5.545,0,0,0-5.505-5.443,5.45,5.45,0,0,0-5.443,5.443A5.4,5.4,0,0,0,282.116-185.735ZM286.2-149.8v-31.175h-8.041V-149.8Z",
    transform: "translate(462.012 869.391)",
    fill: "#242424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLavoroAi);
export default __webpack_public_path__ + "static/media/lavoro-ai.c8e0fe09804f80f241581faef39a0bcb.svg";
export { ForwardRef as ReactComponent };